import { render, staticRenderFns } from "./TenantSelect.vue?vue&type=template&id=1259614c&scoped=true&"
import script from "./TenantSelect.vue?vue&type=script&lang=ts&"
export * from "./TenantSelect.vue?vue&type=script&lang=ts&"
import style0 from "./TenantSelect.vue?vue&type=style&index=0&id=1259614c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1259614c",
  null
  
)

export default component.exports